import Status from "../util/status.js"

var model = {};

export default {

    /**
     *
     * @param {*} txtid
     */
    get(txtid){
        if (this.model[txtid]){
           return this.model[txtid]["text"];
        }
        return "";
    },

    /**
     *
     * @param {*} data
     */
    hydrate(data){
        var status = new Status();
        var model = {};

        for (var i = 0; i < data.length; i++){
            status = this.hydrateEntry(data[i], status);

            if (!status.success){
                return status;
            }

            var txtid = status.result.txtid;
            model[txtid] = status.result;
        }

        this.model = model;

        status.success = true;
        status.result = this.model;
        return status;
    },

    /**
     *
     * @param {*} data
     * @param {*} status
     */
    hydrateEntry(data, status) {
        var model = {};

        if (typeof data !== "object"){
            status.message = "ERROR: text entry is not an object";
            return status;
        }

        //required fields
        if (typeof data["txtid"] === "string"){
            model.txtid = data["txtid"];
        }
        else{
            status.message = "ERROR: text field 'txtid' malformatted or missing";
            return status;
        }

        if (typeof data["text"] === "string"){
            model.text = data["text"];
        }
        else{
            status.message = "ERROR: text field 'text' malformatted or missing";
            return status;
        }

        //optional

        if (typeof data["textprogramvariant_set"] === "object" && data["textprogramvariant_set"].length > 0){
            var variantList = data["textprogramvariant_set"];

            for (var i = 0; i < variantList.length; i++){
                var variantData = variantList[i];

                //@carly to do - add "webventure" to const file
                //@carly to do - split up more?
                if (typeof variantData["program"] === "object" &&
                    typeof variantData["program"]["txtid"] === "string" &&
                           variantData["program"]["txtid"] === "lv-express" &&
                    typeof variantData["text"] === "string"){

                        model.text = variantData["text"];
                }
            }
        }

        status.success = true; 
        status.result = model;
        return status;
    }
}